export const VERSION = "v22.1-e780c370b";
export const SCM_REVISION = "e780c370b9272c36eab718bacaa100537fd8d215";